export default __webpack_public_path__ + "static/assets/7c610f4d249655d2fc928bed456b8e48.svg";